<mat-card class="card" [ngClass]="{'consent-width': step === 1}">
  <div *ngIf="step == 2">
    <header>
      <h3 style="font-size: 2em;">{{'REG_T1' | translate}}</h3>
    </header>
    <form style="padding-top: 5%;" [formGroup]="registrationForm" (ngSubmit)="register()">
      <div class="inputForm">
        <p class="label" [ngClass]="{'label-err': nameErr}">{{'REG_NAME' | translate}}*</p>
        <input placeholder="{{'REG_NAME' | translate}}" formControlName='name' [ngClass]="{'error': nameErr}"
          (focus)="clearNameErr()" (focusout)="focusOutCheck('name')">
        <p *ngIf="nameErr" class="error-text">{{nameErr}}</p>
        <p class="label" [ngClass]="{'label-err': emailErr}">Email*</p>
        <input placeholder="Email" formControlName='email' [ngClass]="{'error': emailErr}" (focus)="clearEmailErr()"
          (focusout)="focusOutCheck('email')">
        <p *ngIf="emailErr" class="error-text">{{emailErr}}</p>
        <p class="label" [ngClass]="{'label-err': passwordErr}">Password*</p>
        <input type="password" placeholder="Password" formControlName='password' [ngClass]="{'error': passwordErr}"
          (focus)="clearPasswordErr()" (focusout)="focusOutCheck('password')">
        <p *ngIf="passwordErr" class="error-text">{{passwordErr}}</p>
      </div>

          <div mat-icon-button (click)="toggleAdditionalInfo()" >
            <mat-icon>{{ showAdditionalInfo ? 'info' : 'info_outline' }}</mat-icon>
          </div>
          <mat-card-content *ngIf="showAdditionalInfo">
            <p>{{'REG_INFO' | translate}}</p>
          </mat-card-content>

      <p class="label" [ngClass]="{'label-err': passwordErr}">{{'REG_CODE' | translate}}*</p>
        <input type="SecurityCode" placeholder="{{'REG_CODE' | translate}}" formControlName='securitycode' [ngClass]="{'error': securityErr}"
          (focus)="clearPasswordErr()" (focusout)="focusOutCheck('password')">
        <p *ngIf="securityErr" class="error-text">{{securityErr}}</p>



    <!-- <mat-checkbox formControlName='lcFlag'>{{'IS_P27' | translate}}</mat-checkbox> -->
      <div class="buttons">
        <mat-spinner *ngIf="loading" diameter="30"></mat-spinner>
        <button class="button" *ngIf="!loading" routerLinkActive="router-link-active"> {{'LOG_ON_B1' |
          translate}}</button>
      </div>
      <div style="margin-top: 1rem;">
        {{'REG_P1' | translate}}
      </div>
    </form>
  </div>
  <mat-card-content *ngIf="step == 1">

    <!--INFORMATION SHEET-->
    <div style="text-align: justify;">
      <h1>{{'IS_T1' | translate}}</h1>
      <h4 style="margin-bottom: 0px">{{'IS_T2' | translate}}</h4>
      <p style="margin-top: 2px">
        {{'IS_P1' | translate}}
      </p>
      <h4 style="margin-bottom: 0px">{{'IS_T3' | translate}}</h4>
      <p style="margin-top: 2px" [innerHtml]="'IS_P2' | translate">
      </p>
      <h4 style="margin-bottom: 0px">{{'IS_T4' | translate}}</h4>
      <p style="margin-top: 2px">
        {{'IS_P3' | translate}}
      </p>
      <h4 style="margin-bottom: 0px">{{'IS_T5' | translate}}</h4>
      <p style="margin-top: 2px">
        {{'IS_P4' | translate}}
      </p>
      <h4 style="margin-bottom: 0px">{{'IS_T6' | translate}}</h4>
      <ul style="font-family: akzidenz-grotesk-roman;">
        <li>
          {{'IS_P5' | translate}}
        </li>
        <li>
          {{'IS_P6' | translate}}
        </li>
        <li>
          {{'IS_P7' | translate}}
        </li>
        <li>
          {{'IS_P8' | translate}}
        </li>
        <li>
          {{'IS_P9' | translate}}
        </li>
        <li>
          {{'IS_P10' | translate}}
        </li>
        <li>
          {{'IS_P11' | translate}}
        </li>
        <li>
          {{'IS_P12' | translate}}
        </li>
        <li>
          {{'IS_P13' | translate}}
        </li>
      </ul>
      <h4 style="margin-bottom: 0px">{{'IS_T7' | translate}}</h4>
      <p style="margin-top: 2px">
        {{'IS_P14' | translate}}
      </p>
      <h4 style="margin-bottom: 0px">{{'IS_T8' | translate}}</h4>
      <p style="margin-top: 2px">
        {{'IS_P15' | translate}}
      </p>
      <h4>{{'IS_T9' | translate}}</h4>
      <h4 style="margin-bottom: 0px; text-decoration: underline;">{{'IS_T10' | translate}}</h4>
      <p style="margin-top: 2px">
        Dr Helge Gillmeister (email: helge@essex.ac.uk) <br />
        Dr Loes van Dam (email: lvandam@essex.ac.uk) <br />
        Dr Caterina Cinel (email: ccinel@essex.ac.uk) <br />
        Dr Vito de Feo (email: vito.defeo@essex.ac.uk)
      </p>
      <h4 style="margin-bottom: 0px; text-decoration: underline;">{{'IS_T11' | translate}}</h4>
      <p style="margin-top: 2px">
        Prof Sheina Orbell (sorbell@essex.ac.uk)
      </p>
      <h4 style="margin-bottom: 0px; text-decoration: underline;">
        {{'IS_T12' | translate}}
      </h4>
      <p style="margin-top: 2px">
        Sarah Manning-Press, Research & Enterprise Office, University of Essex, Wivenhoe Park, CO4 3SQ, Colchester.
        Email: sarahm@essex.ac.uk. Phone: 01206-873561
      </p>
    </div>

    <!--CONSENT FORM-->
    <div>
      <h1>{{'IS_T13' | translate}}</h1>
      <ol type="1" style="font-family: akzidenz-grotesk-roman;">
        <li>{{'IS_P16' | translate}} </li>

        <li>{{'IS_P17' | translate}}</li>

        <li>{{'IS_P18' | translate}}</li>

        <li>{{'IS_P19' | translate}}</li>

        <li>{{'IS_P20' | translate}}</li>

        <li>{{'IS_P21' | translate}}</li>

        <li>{{'IS_P22' | translate}}</li>
        <li>{{'IS_P23' | translate}}</li>
      </ol>

      <p>
        <b>
          {{'IS_P24' | translate}}
        </b>
      </p>
    </div>

    <mat-checkbox [(ngModel)]="participate">{{'IS_P25' | translate}}</mat-checkbox>

    <br><br>
    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    <div *ngIf="!loading" style="display: flex; justify-content: center;">
      <button mat-raised-button class="consentButton" [disabled]="isDisabled" (click)="showForm()"
        [matTooltipDisabled]="!isDisabled" matTooltip="{{'IS_P26' | translate}}">
        {{'HOME_REGISTER' | translate}}
      </button>
    </div>

  </mat-card-content>

  <div *ngIf="step == 3">
    <h2 style="text-align: center;">{{'REG_T2' | translate}}</h2>
    <p> {{'REG_P2' | translate}}
    </p>
    <div style="display: flex; justify-content: center;">
      <button class="consentButton" mat-raised-button (click)="openResend()">{{'REG_B1' | translate}}</button>
    </div>
  </div>

</mat-card>
